export default "__VITE_ASSET__93b20727__"